import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { setEmail, setAccessToken, getEmail, getAccessToken } from './services/User.js';

const GOOGLE_CLIENT_ID = '495656309447-l15qpfuru9gt0bs335oo1c4vj6ctbv5u.apps.googleusercontent.com';

const isServitechEmail = (email) => typeof email === 'string' && email.toLowerCase().endsWith('@servitech.com');

export default function LoginComponent(props) {
    const email = getEmail();
    const accessToken = getAccessToken();
    const navigate = useNavigate()

    const [loginError, setLoginError] = useState(false);
    const [loginLoading, setLoginLoading] = useState(null);

    const handleLoginFailure = () => {
        setLoginError(true);
        setLoginLoading(false);
        setTimeout(() => {
            setLoginError(false);
            setLoginLoading(null);
            navigate("/", {replace:true})
        }, 3000);
    }

    const handleOnRequest = () => {
        setLoginLoading(true);
    }

    const handleLogin = async (response) => {
        handleOnRequest()
        const {
            credential = '',
        } = response;

        if (credential) {
            let fetchLogInJson;
            try {
                const fetchLogIn = await fetch('https://google-auth-node-login-bjudfyf5za-uc.a.run.app/login', { method: "POST", headers: { 'Content-type': 'application/json' }, body: JSON.stringify({ credential: credential, GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID }) });
                // const fetchLogIn = await fetch('http://localhost:4000/login', { method: "POST", headers: { 'Content-type': 'application/json' }, body: JSON.stringify({ credential: credential, GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID }) });
                fetchLogInJson = await fetchLogIn.json();
            } catch (err) {
                console.error(err);
            }
            if (fetchLogInJson && fetchLogInJson.user) {
                if (isServitechEmail(fetchLogInJson.user.email)) {
                    setEmail(fetchLogInJson.user.email);
                    setAccessToken(fetchLogInJson.user.accessToken)
                    setLoginLoading(false);
                } else {
                    handleLoginFailure();
                }
            } else {
                handleLoginFailure();
            }
        } else {
            handleLoginFailure();
        }
    }

    useEffect(() => {
        // The Google script loads async, so wait for it if it isn't ready yet
        const initGoogleSignIn = () => {
            if (!window.google) {
                return false;
            }
            window.google.accounts.id.initialize({
                client_id: GOOGLE_CLIENT_ID,
                callback: handleLogin
            });
            window.google.accounts.id.renderButton(
                document.getElementById("googleSignInButtonDiv"),
                { theme: "outline", size: "large", shape: "rectangle", logo_alignment: "left", text: "signin_with" }  // customization attributes
            );
            window.google.accounts.id.prompt();
            return true;
        }
        if (initGoogleSignIn()) {
            return;
        }
        const timer = setInterval(() => {
            if (initGoogleSignIn()) {
                clearInterval(timer);
            }
        }, 100);
        return () => clearInterval(timer);
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (accessToken && email) {
            navigate("/")
        }
    }, [accessToken, email, navigate])

    if (loginLoading) {
        return (
            <div className="login-wrapper">
                Loading ...
            </div>
        );
    }

    return (
        <div>
            {(!loginError || loginError === 'false') && (
                <div className="login-wrapper align-center">
                    <div id="googleSignInButtonDiv"></div>
                </div>
            )}
            {(loginError || loginError === 'true') && (
                <div className="login-wrapper align-center">Login failed, please try again with a servitech email.</div>
            )}
        </div>
    )
}